
import Vue from 'vue'

const component = Vue.extend({})

Vue.component('AUnread', component)
export default component
